'use strict';

var recaptcha = require('core/components/recaptcha');

function checkFormElementsState(elements) {
    elements.map(function(element){
        let formElement = element.formElement;
        let requiredState = element.required;
        let visible = element.visible;
        toggleRequiredState(requiredState, formElement);
        if (visible === true) {
            contactUsShowDynamicElements(formElement);
        } else {
            contactUsHideDynamicElements(formElement);
        }
    })
}

function contactUsShowDynamicElements(element) {
    if(element.hasClass('d-none')) {
        element.removeClass('d-none');
    }
};

function contactUsHideDynamicElements(element) {
    element.addClass('d-none');
};

function toggleRequiredState(requiredState, formElement) {
    // if element is optional, remove required attribute from
    // input, and remove required class
    if (requiredState === true) {
        formElement.find('input, select').prop('required', true).attr('aria-required', true);
        formElement.find('input, select').addClass('required');
        formElement.find('.requiredIndicator').removeClass('d-none');
    } else {
        formElement.find('input, select').prop('required', false).attr('aria-required', false);
        formElement.find('input, select').removeClass('required');
        formElement.find('.requiredIndicator').addClass('d-none');
    }
}

function dynamicFormControls(topic)  {
    var form = $('.contact-us-form');
    var formElements = {
        supportQuestions: form.find('.support-question-row'),
        itemInquiryTopics: form.find('.item-inquiry-topic-row'),
        returnInquiryTopics: form.find('.returns-support-topic-row'),
        personalInformationTopics: form.find('.personal-information-topic-row'),
        nameSection: form.find('.contact-us-name-row'),
        phoneSection: form.find('.contact-us-phone'),
        emailSection: form.find('.contact-us-email'),
        phoneSection: form.find('.contact-us-phone'),
        streetAddressSection: form.find('.contact-us-street-address'),
        streetAddressTwoSection: form.find('.contact-us-street-address-two'),
        citySection: form.find('.contact-us-city'),
        stateSection: form.find('.contact-us-state'),
        zipCodeSection: form.find('.contact-us-zip-code'),
        orderNumberSection: form.find('.contact-us-order-number'),
        contactUsCommentSection: form.find('.contact-us-comment')

    };
    // massive if/else needed to hide/unhide the appropriate
    // form fields based on user selection from dropdowns.
    // we need to account for times when a user makes two or more selections
    // in the same session.

    if (topic === 'Billing/Pricing Question') {
        let elements = [
            {
                formElement: formElements.itemInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.returnInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.personalInformationTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.nameSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.phoneSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.emailSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.streetAddressSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.streetAddressTwoSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.citySection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.stateSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.zipCodeSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.orderNumberSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.contactUsCommentSection,
                required: false,
                visible: true,
            },
        ]
        checkFormElementsState(elements);
        //elements to show/hide
    } else if (topic === 'Cancel Order') {
        let elements = [
            {
                formElement: formElements.itemInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.returnInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.personalInformationTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.nameSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.phoneSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.emailSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.streetAddressSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.streetAddressTwoSection,
                required: false,
                visible: true,
            },
            {
                formElement: formElements.citySection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.stateSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.zipCodeSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.orderNumberSection,
                required: false,
                visible: true,
            },
            {
                formElement: formElements.contactUsCommentSection,
                required: false,
                visible: true,
            },
        ]
        checkFormElementsState(elements);
    //this one handles the instance "item query" utilizing a sub topic
    } else if (topic === 'Item Inquiry') {
        let elements = [
            {
                formElement: formElements.itemInquiryTopics,
                required: false,
                visible: true,
            },
            {
                formElement: formElements.returnInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.personalInformationTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.nameSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.phoneSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.emailSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.streetAddressSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.streetAddressTwoSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.citySection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.stateSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.zipCodeSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.orderNumberSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.contactUsCommentSection,
                required: false,
                visible: false,
            },
        ]
        checkFormElementsState(elements);
        //reset other subtopic dropdowns
        $('#personal-information-topic').prop('selectedIndex',0);
        $('#return-topic').prop('selectedIndex',0);
        let subTopic = ''
        $('#item-topic').on('change', function(){
            subTopic = $(this).val();
            if (subTopic === 'Item Back-Order Status') {
                let elements = [
                    {
                        formElement: formElements.itemInquiryTopics,
                        required: false,
                        visible: true,
                    },
                    {
                        formElement: formElements.returnInquiryTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.personalInformationTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.nameSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.phoneSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.emailSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.streetAddressSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.streetAddressTwoSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.citySection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.stateSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.zipCodeSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.orderNumberSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.contactUsCommentSection,
                        required: false,
                        visible: true,
                    },
                ]
                checkFormElementsState(elements);
            } else if (subTopic === 'Item Information Request') {
                let elements = [
                    {
                        formElement: formElements.itemInquiryTopics,
                        required: false,
                        visible: true,
                    },
                    {
                        formElement: formElements.returnInquiryTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.personalInformationTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.nameSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.phoneSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.emailSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.streetAddressSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.streetAddressTwoSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.citySection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.stateSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.zipCodeSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.orderNumberSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.contactUsCommentSection,
                        required: false,
                        visible: true,
                    },
                ]
                checkFormElementsState(elements);
            }
        });
    //this one handles the instance "returns" utilizing a sub topic
    } else if (topic === 'Returns') {
        let elements = [
            {
                formElement: formElements.itemInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.returnInquiryTopics,
                required: false,
                visible: true,
            },
            {
                formElement: formElements.personalInformationTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.nameSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.phoneSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.emailSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.streetAddressSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.streetAddressTwoSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.citySection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.stateSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.zipCodeSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.orderNumberSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.contactUsCommentSection,
                required: false,
                visible: false,
            },
        ]
        checkFormElementsState(elements);
        //reset other subtopic dropdowns
        $('#item-topic').prop('selectedIndex',0);
        $('#personal-information-topic').prop('selectedIndex',0);
        let subTopic = '';
        $('#return-topic').on('change', function(){
            subTopic = $(this).val();
            if (subTopic === 'Return Inquiry') {
                let elements = [
                    {
                        formElement: formElements.itemInquiryTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.returnInquiryTopics,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.personalInformationTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.nameSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.phoneSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.emailSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.streetAddressSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.streetAddressTwoSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.citySection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.stateSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.zipCodeSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.orderNumberSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.contactUsCommentSection,
                        required: false,
                        visible: true,
                    },
                ]
                checkFormElementsState(elements);
            } else if (subTopic === 'Received Incorrect/Defective Merchandise') {
                let elements = [
                    {
                        formElement: formElements.itemInquiryTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.returnInquiryTopics,
                        required: false,
                        visible: true,
                    },
                    {
                        formElement: formElements.personalInformationTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.nameSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.phoneSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.emailSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.streetAddressSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.streetAddressTwoSection,
                        required: false,
                        visible: true,
                    },
                    {
                        formElement: formElements.citySection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.stateSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.zipCodeSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.orderNumberSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.contactUsCommentSection,
                        required: false,
                        visible: true,
                    },
                ]
                checkFormElementsState(elements);
            }
        });
    } else if (topic === 'Order Status') {
        let elements = [
            {
                formElement: formElements.itemInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.returnInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.personalInformationTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.nameSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.phoneSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.emailSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.streetAddressSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.streetAddressTwoSection,
                required: false,
                visible: true,
            },
            {
                formElement: formElements.citySection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.stateSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.zipCodeSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.orderNumberSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.contactUsCommentSection,
                required: false,
                visible: true,
            },
        ]
        checkFormElementsState(elements);
    } else if (topic === 'International') {
        let elements = [
            {
                formElement: formElements.itemInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.returnInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.personalInformationTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.nameSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.phoneSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.emailSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.streetAddressSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.streetAddressTwoSection,
                required: false,
                visible: true,
            },
            {
                formElement: formElements.citySection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.stateSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.zipCodeSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.orderNumberSection,
                required: true,
                visible: true,
            },
            {
                formElement: formElements.contactUsCommentSection,
                required: false,
                visible: true,
            },
        ]
        checkFormElementsState(elements);
    } else if (topic === 'Personal Information Request') {
        let elements = [
            {
                formElement: formElements.itemInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.returnInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.personalInformationTopics,
                required: false,
                visible: true,
            },
            {
                formElement: formElements.nameSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.phoneSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.emailSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.streetAddressSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.streetAddressTwoSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.citySection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.stateSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.zipCodeSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.orderNumberSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.contactUsCommentSection,
                required: false,
                visible: false,
            },
        ]
        checkFormElementsState(elements);
        //reset other subtopic dropdowns
        $('#return-topic').prop('selectedIndex',0);
        $('#item-topic').prop('selectedIndex',0);
        let subTopic = '';
        $('#personal-information-topic').on('change', function() {
            subTopic = $(this).val();
            if (subTopic === 'Unsubscribe') {
                let elements = [
                    {
                        formElement: formElements.itemInquiryTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.returnInquiryTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.personalInformationTopics,
                        required: false,
                        visible: true,
                    },
                    {
                        formElement: formElements.nameSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.phoneSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.emailSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.streetAddressSection,
                        required: false,
                        visible: true,
                    },
                    {
                        formElement: formElements.streetAddressTwoSection,
                        required: false,
                        visible: true,
                    },
                    {
                        formElement: formElements.citySection,
                        required: false,
                        visible: true,
                    },
                    {
                        formElement: formElements.stateSection,
                        required: false,
                        visible: true,
                    },
                    {
                        formElement: formElements.zipCodeSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.orderNumberSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.contactUsCommentSection,
                        required: false,
                        visible: true,
                    },
                ]
                checkFormElementsState(elements);
            } else if (subTopic === 'Do Not Sell My Personal Information' || subTopic === 'Delete My Personal Information' || subTopic === 'I have other questions about my Personal Data') {
                let elements = [
                    {
                        formElement: formElements.itemInquiryTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.returnInquiryTopics,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.personalInformationTopics,
                        required: false,
                        visible: true,
                    },
                    {
                        formElement: formElements.nameSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.phoneSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.emailSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.streetAddressSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.streetAddressTwoSection,
                        required: false,
                        visible: true,
                    },
                    {
                        formElement: formElements.citySection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.stateSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.zipCodeSection,
                        required: true,
                        visible: true,
                    },
                    {
                        formElement: formElements.orderNumberSection,
                        required: false,
                        visible: false,
                    },
                    {
                        formElement: formElements.contactUsCommentSection,
                        required: false,
                        visible: true,
                    },
                ]
                checkFormElementsState(elements);
            }
        });
        } else if (topic === 'Sign-Up to Receive Jewelry Catalogs') {
            let elements = [
                {
                    formElement: formElements.itemInquiryTopics,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.returnInquiryTopics,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.personalInformationTopics,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.nameSection,
                    required: true,
                    visible: true,
                },
                {
                    formElement: formElements.phoneSection,
                    required: true,
                    visible: true,
                },
                {
                    formElement: formElements.emailSection,
                    required: true,
                    visible: true,
                },
                {
                    formElement: formElements.streetAddressSection,
                    required: true,
                    visible: true,
                },
                {
                    formElement: formElements.streetAddressTwoSection,
                    required: false,
                    visible: true,
                },
                {
                    formElement: formElements.citySection,
                    required: true,
                    visible: true,
                },
                {
                    formElement: formElements.stateSection,
                    required: true,
                    visible: true,
                },
                {
                    formElement: formElements.zipCodeSection,
                    required: true,
                    visible: true,
                },
                {
                    formElement: formElements.orderNumberSection,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.contactUsCommentSection,
                    required: false,
                    visible: false,
                },
            ]
            checkFormElementsState(elements);
        } else if (topic === 'Other Question/Comment') {
            let elements = [
                {
                    formElement: formElements.itemInquiryTopics,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.returnInquiryTopics,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.personalInformationTopics,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.nameSection,
                    required: true,
                    visible: true,
                },
                {
                    formElement: formElements.phoneSection,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.emailSection,
                    required: true,
                    visible: true,
                },
                {
                    formElement: formElements.streetAddressSection,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.streetAddressTwoSection,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.citySection,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.stateSection,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.zipCodeSection,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.orderNumberSection,
                    required: false,
                    visible: false,
                },
                {
                    formElement: formElements.contactUsCommentSection,
                    required: false,
                    visible: true,
                },
            ]
            checkFormElementsState(elements);
    } else if (topic === 'Please Select a Topic') {
        let elements = [
            {
                formElement: formElements.itemInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.returnInquiryTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.personalInformationTopics,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.nameSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.phoneSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.emailSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.streetAddressSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.streetAddressTwoSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.citySection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.stateSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.zipCodeSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.orderNumberSection,
                required: false,
                visible: false,
            },
            {
                formElement: formElements.contactUsCommentSection,
                required: false,
                visible: false,
            },
        ]
        checkFormElementsState(elements);
    }
}

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message-container').length === 0) {
        $('.contact-us-form').prepend(
            '<div class="contact-us-signup-message-container"></div>'
        );

    } else {
        $('.contact-us-signup-message-container').empty();
    }

    if (data.success) {
        $('.contact-us-signup-message-container')
        .append('<div class="alert ' + status + '">Thank You. Your message has been sent. We will contact you shortly if your message requires a response.</div>');

        $('#aria-status-message').text('Thank You. Your message has been sent. We will contact you shortly if your message requires a response.')
    } else {
        $('.contact-us-signup-message-container')
        .append('<div class="alert ' + status + '">' + data.msg + '</div>');

        $('#aria-status-message').text(data.msg);
    }


    setTimeout(function () {
        button.removeAttr('disabled');
    }, 3000);
}


module.exports = {
    subscribeContact: function () {
        $('form.contact-us').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var button = $('.subscribe-contact-us');
            var url = form.attr('action');

            $.spinner().start();
            button.attr('disabled', true);
            recaptcha.check(e, {
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    displayMessage(data, button);
                    if (data.success) {
                        $('.contact-us').trigger('reset');
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    displayMessage(err, button);
                }
            });
        });
    },
    topicChange: function() {
        //checking for topic
        $('#contact-topic').on('change', function(){
            let topic = $(this).val();
            dynamicFormControls(topic);
        });
    }
};
